export * from './DocumentAvatar';
